export default __webpack_public_path__ + "static/media/Wallet_light.cd78acc8.svg";